import React, {
    ReactElement,
    Component,
    useEffect,
    useState,
    useRef,
    // SetStateAction,
    useCallback,
    Fragment,
    useContext,
    useMemo, Dispatch, SetStateAction
} from 'react';
import "./backup-scheduler.less";
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Col, Row, Popover, Tooltip, Descriptions, Select, Spin, Table, Typography } from "antd";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from '@fullcalendar/interaction'
import '@fortawesome/fontawesome-free/css/all.css';
import get_time from "../../../../shared-functions/get-time";
import { http_request_new } from '../../../../http-worker/http-func';
import { post_processes_args_default, response_type } from '../../../../http-worker/function/interfaces';
import MongoDB from "../../../../img/imgs/mongodb.png";
import PostgreSQL from "../../../../img/imgs/PostgreSQL.png";
import InfluxDB from "../../../../img/imgs/influxdb.png";
import { NoPermissionVisibleContext } from '../../contexts/no-permission-visible';
import { DatacenternameContext } from '../../../../contexts/datacenter-name';
import { IUserInfoType, UserInfoContext } from '../../../../contexts/user-info';
import NoPermissionModal from '../../component/no-permission-modal';
import {http_get} from "../../common-file/service";
import {ListItemSelectedContext} from "../../contexts/list-item-selected";

export interface schedule_item {
    id: string,
    title: string,
    start?: string,
    service_name: string,
    name?: string,
    status?: string,
    instance_name?: string,
    instance?: {
        id?: string,
        name?: string
    },
    subscription_id?: string,
    backup_type?: string,
    end?: string,
    db_storage?: {
        id: string,
        name: string,
        storage_device_type: string,
    },
    duration?: string,
    expired_at?: string,
    message?: string,
    trigger_mode?: string,
    advanced?: Object,
    db_schedule?: {
        id: string,
        name: string
    },
    description?: string,
    frequency?: string,
    schedule?: string,
    time_description?: string,
    db_backup_config?: {
        id: string,
        name: string
    },
    next?: string[]
}

export interface schedule_type {
    id: string,
    title: string,
    start: string,
    service_name: string,

    count?: number,
    instance_name?: string,
    end?: string,
    repeatExecute?: boolean,
    borderColor?: string,
    backgroundColor?: string,
    color?: string,
    date?: string,
    display?: string,
    status?: string,

    schedule_list?: schedule_item[]
}

export interface format_datasource {
    dayGridMonth: schedule_type[],
    timeGridWeek: schedule_item[]
}

export interface backup_scheduler_type {
    id: string,
    title: string,
    start: string,
    count?: number,
    instance_name?: string,
    database?: string,
    end?: string,
    repeatExecute: boolean,
    borderColor?: string,
    backgroundColor?: string,
    color?: string,
    date?: string,
    schedule_list?: any[]
}

export interface upcoming_schedule {
    service?: string,
    name?: string,
    time?: string
}

// export function format_UtC(utc_datetime: string) {
//     // 转为正常的时间格式 年-月-日 时:分:秒
//     var T_pos = utc_datetime.indexOf('T');
//     var Z_pos = utc_datetime.indexOf('Z');
//     var year_month_day = utc_datetime.substr(0, T_pos);
//     var hour_minute_second = utc_datetime.substr(T_pos + 1, Z_pos - T_pos - 1);
//     var new_datetime = year_month_day + " " + hour_minute_second; // 2017-03-31 08:02:06

//     // 处理成为时间戳，增加8个小时，北京时间比utc时间多八个时区
//     let timestamp: any = (new Date(Date.parse(new_datetime)).getTime()) / 1000 + 8 * 60 * 60;
//     // 时间戳转为时间
//     var d = new Date(timestamp * 1000);
//     var clock = d.getFullYear() + "-";
//     if ((d.getMonth() + 1) < 10) clock += "0";
//     clock += (d.getMonth() + 1) + "-";
//     if (d.getDate() < 10) clock += "0";
//     clock += d.getDate() + " ";
//     if (d.getHours() < 10) clock += "0";
//     clock += d.getHours() + ":";
//     if (d.getMinutes() < 10) clock += '0';
//     clock += d.getMinutes() + ":";
//     if (d.getSeconds() < 10) clock += '0';
//     clock += d.getSeconds();
//     return clock;
// }

export function backup_post_process({ response, resolve }: post_processes_args_default) {
    (response as any)?.items?.forEach((response_each: response_type) => {
        (response_each as any).name = (response_each as any)?.db_backup_id;
        (response_each as any).id = (response_each as any)?.db_backup_id;
        (response_each as any).service_name = (response_each as any)?.service;
        (response_each as any).title = (response_each as any)?.service;
        (response_each as any).start = (response_each as any)?.start_time;
        (response_each as any).end = (response_each as any)?.end_time;
        (response_each as any).instance_name = (response_each as any)?.instance.name;
        (response_each as any).status = (response_each as any)?.status || "Pending";
        (response_each as any).block = true;
        // // (response_each as any).backup_type = (response_each as any).selected_database ? "Incremental" : "Full";
        // (response_each as any).selected_database = (response_each as any).selected_database ? (response_each as any).selected_database : "<All Databases>";
        delete (response_each as any).service;
    });
    resolve(response);
}

export function backup_schedule_post_process({ response, resolve }: post_processes_args_default) {
    (response as any)?.items?.forEach((response_each: response_type) => {
        (response_each as any).name = (response_each as any)?.db_schedule?.name;
        (response_each as any).id = (response_each as any)?.db_schedule?.id;
        (response_each as any).service_name = (response_each as any)?.service;
        (response_each as any).title = (response_each as any)?.service;
        (response_each as any).instance_name = (response_each as any)?.instance?.name;
        (response_each as any).backup_type = "Full";
        // (response_each as any).start = (response_each as any).start_time;
        // (response_each as any).end = (response_each as any).end_time;
        delete (response_each as any)?.db_schedule;
        delete (response_each as any)?.service;
    });
    resolve(response);
}

const BackupScheduler: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {
    // eslint-disable-next-line
    const { formatMessage } = props?.intl;
    // const [backup_scheduler, set_backup_scheduler]: [backup_scheduler_type[], React.Dispatch<React.SetStateAction<backup_scheduler_type[]>>] = useState<backup_scheduler_type[]>([]);
    // const [backup_scheduler_month, set_backup_scheduler_month]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]);
    const [backup_scheduler_display, set_backup_scheduler_display]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]);
    const { Option } = Select;
    const [source_list, set_source_list]: [schedule_item[] | undefined, React.Dispatch<React.SetStateAction<schedule_item[] | undefined>>] = useState<schedule_item[] | undefined>();
    const [source_schedule_list, set_source_schedule_list]: [schedule_item[] | undefined, React.Dispatch<React.SetStateAction<schedule_item[] | undefined>>] = useState<schedule_item[] | undefined>();
    // 将每个 schedule 的 next 抽离开
    const [format_schedule_list, set_format_schedule_list]: [schedule_item[] | undefined, React.Dispatch<React.SetStateAction<schedule_item[] | undefined>>] = useState<schedule_item[] | undefined>();
    // upcoming list
    const [upcoming_schedule_list, set_upcoming_schedule_list]: [upcoming_schedule[] | undefined, React.Dispatch<React.SetStateAction<upcoming_schedule[] | undefined>>] = useState<upcoming_schedule[] | undefined>();
    const [upcoming_display_list, set_upcoming_display_list]: [upcoming_schedule[] | undefined, React.Dispatch<React.SetStateAction<upcoming_schedule[] | undefined>>] = useState<upcoming_schedule[] | undefined>();

    const [backup_list, set_backup_list]: [schedule_item[] | undefined, React.Dispatch<React.SetStateAction<schedule_item[] | undefined>>] = useState<schedule_item[] | undefined>();
    const [all_backup_list, set_all_backup_list]: [schedule_item[] | undefined, React.Dispatch<React.SetStateAction<schedule_item[] | undefined>>] = useState<schedule_item[] | undefined>();

    const [filter_backup_list, set_filter_backup_list]: [schedule_item[] | undefined, React.Dispatch<React.SetStateAction<schedule_item[] | undefined>>] = useState<schedule_item[] | undefined>();
    const [backup_scheduler, set_backup_scheduler]: [schedule_type[] | undefined, React.Dispatch<React.SetStateAction<schedule_type[] | undefined>>] = useState<schedule_type[] | undefined>();
    // const [format_scheduler, set_format_scheduler]: [format_datasource | undefined, React.Dispatch<React.SetStateAction<format_datasource | undefined>>] = useState<format_datasource | undefined>();
    const [view_type, set_view_type]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(sessionStorage.getItem('scheduler_view') || "dayGridMonth");
    const [service_type, set_service_type]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("all");
    const [loading, set_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);
    const [start_time, set_start_time]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState<string | undefined>();
    const [end_time, set_end_time]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState<string | undefined>();
    const [current_time, set_current_time]: [number | undefined, React.Dispatch<React.SetStateAction<number | undefined>>] = useState<number | undefined>();
    const set_list_item_selected: Dispatch<SetStateAction<object>> = useContext(ListItemSelectedContext)[1];
    // const [loading_done, set_loading_done]: [{ [key: string]: 0 | 1 }, React.Dispatch<React.SetStateAction<{ [key: string]: 0 | 1 }>>] = useState<{
    //     [key: string]: 0 | 1;
    // }>({});
    const set_no_permission_visible: React.Dispatch<React.SetStateAction<boolean>> = useContext(NoPermissionVisibleContext)[1];
    // eslint-disable-next-line
    const [user_info, set_user_info]: [IUserInfoType, React.Dispatch<React.SetStateAction<IUserInfoType>>] = useContext(UserInfoContext);
    const datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        [sso_subscriptions, set_sso_subscriptions]: [any, React.Dispatch<React.SetStateAction<any>>] = useState([]);

    const backup_status: any = useRef([
        { status: "Succeeded", color: "bg-succeeded" },
        { status: "Failed", color: "bg-failed" },
        { status: "Running", color: "bg-running" },
        { status: "Pending", color: "bg-pending" }
    ]);

    useEffect((): void => {
        set_current_time(new Date().getTime());
    }, [])

    useEffect(() => {
        if (datacenter_name && props && user_info?.ssoRole) {
            (async () => {
                if (user_info?.ssoRole === "globalAdmin") {
                    // /v4.0/subscriptions?maxResults=999
                    const sso_subscription: any = await http_get(`/v4.0/subscriptions?maxResults=9999&page=&direction=&property=`, props) || {};
                    set_sso_subscriptions(sso_subscription?.data?.resources || []);
                    if (!(sso_subscription?.data?.resources?.length > 0)) set_no_permission_visible(true);
                } else {
                    // /v4.0/users/me
                    const sso_subscription: any = await http_get(`/v4.0/users/me`,props);
                    set_sso_subscriptions(sso_subscription?.data?.userSubscriptions || []);
                    if (!(sso_subscription?.data?.userSubscriptions?.length > 0)) set_no_permission_visible(true);
                }
            })()
        }
        // eslint-disable-next-line
    }, [user_info?.ssoRole, datacenter_name, set_sso_subscriptions, set_no_permission_visible]);

    useEffect((): void => {
        !!sso_subscriptions?.length && (async () => {
            set_loading(true);
            await http_request_new({
                key: 'backup',
                props: props,
                func: set_source_list,
                // url: `/backup/dbBackups?instanceId=${instance_item_selected.instance_id}`,
                url: `/backup/dbBackups`,
                method: 0,
                post_process: backup_post_process
            }).then((data: any)=> (!data) && set_source_list([]));
        })();
        // eslint-disable-next-line
    }, [sso_subscriptions])

    useEffect((): void => {
        !!sso_subscriptions?.length && (async () => {
            set_loading(true);
            start_time && end_time && await http_request_new({
                key: 'backup_schedule',
                props: props,
                func: set_source_schedule_list,
                url: `/backup/dbSchedules/all?from=${start_time}&to=${end_time}`,
                method: 0,
                post_process: backup_schedule_post_process
            }).then((data: any)=> (!data) && set_source_schedule_list([]));
        })();
        // eslint-disable-next-line
    }, [start_time, end_time, sso_subscriptions])

    useEffect(() => {
        if (sso_subscriptions?.length) {
            source_list && source_schedule_list && set_loading(false)
        } else {
            set_loading(false)
        }
    }, [source_list, source_schedule_list, sso_subscriptions])

    // useEffect((): void => {
    //     let time = new Date();
    //     set_start_time(`${time.getFullYear()}-${(time.getMonth() + 1) < 10 ? `0${time.getMonth() + 1}` : time.getMonth() + 1}-01T00:00:00Z`);
    //     set_end_time(`${time.getFullYear()}-${(time.getMonth() + 2) < 10 ? `0${time.getMonth() + 2}` : time.getMonth() + 2}-01T00:00:00Z`);
    // }, []).filter(({ status }) => { return status === "Disabled" })

    useEffect((): void => {
        if (source_schedule_list) {
            let format: schedule_item[] = [];
            source_schedule_list?.map(item => {
                item?.next?.length && item?.next?.map(cell => {
                    delete item.next;
                    return format.push(Object.assign({ ...item, start: get_time(cell), start_time: get_time(cell) }))
                })
                return item
            })
            set_format_schedule_list(format?.filter(({ status }) => status === "Enabled")?.sort((a: any, b: any) => { return Date?.parse(a?.start) - Date?.parse(b?.start) }))
        } else {
            set_format_schedule_list([]);
        }
    }, [source_schedule_list])

    const filter_upcoming = useCallback((service: string) => {
        let schedule: upcoming_schedule | undefined = undefined;
        let filter_schedule: schedule_item | undefined = format_schedule_list?.filter(cell => {
            return cell?.service_name === service
        })[0];
        schedule = { service: filter_schedule?.service_name || service, name: filter_schedule?.instance_name, time: filter_schedule?.start };
        return schedule
    }, [format_schedule_list])

    useEffect(() => {
        format_schedule_list && view_type === "dayGridMonth" && set_upcoming_schedule_list([filter_upcoming("MongoDB"), filter_upcoming("PostgreSQL"), filter_upcoming("InfluxDB")])
    }, [format_schedule_list, filter_upcoming, view_type])

    // 当 sessionStorage 为 周/日 时，获取 upcoming data
    useEffect((): void => {
        if (view_type === "dayGridMonth" && upcoming_schedule_list) {
            sessionStorage.setItem("calendar_upcoming", JSON.stringify(upcoming_schedule_list));
        }
    }, [view_type, upcoming_schedule_list])

    useEffect((): void => {
        let data_list: schedule_item[] = [];
        if (source_list) {
            data_list = source_list?.map((item) => {
                item.start = get_time(item?.start as string);
                item.end = get_time(item?.end as string);
                return item
            })
            set_backup_list(data_list);
        }
    }, [source_list])

    // 将执行过的和未执行的合并
    useEffect((): void => {
        backup_list && format_schedule_list && set_all_backup_list([...backup_list, ...format_schedule_list]);
    }, [backup_list, format_schedule_list])

    useEffect((): void => {
        all_backup_list && set_filter_backup_list(service_type === "all" ? all_backup_list :
            all_backup_list?.filter(({ service_name }) => { return service_name === service_type }))
    }, [all_backup_list, service_type])

    // 封装不同日期的排程数据
    useEffect((): void => {
        let scheduler_list: schedule_type[] = [];
        if (filter_backup_list) {
            filter_backup_list?.map(item => {
                let scheduler_same_start: schedule_item[] = [];
                let same_start_list = scheduler_list?.filter(({ service_name, start }) => { return service_name === item?.service_name && start?.slice(0, 10) === item?.start?.slice(0, 10) })
                if (same_start_list?.length) {
                    same_start_list[0]?.schedule_list?.push(item);
                    same_start_list[0]?.schedule_list?.sort((a: any, b: any) => { return Date?.parse(a?.start) - Date?.parse(b?.start) });
                } else {
                    scheduler_same_start?.push(item);
                    scheduler_list?.push({ id: item?.id, service_name: item?.service_name, title: item?.title, start: `${item?.start?.slice(0, 10)} 00:00:00` as string, schedule_list: scheduler_same_start });
                }
                return item
            })
            scheduler_list?.map(item => {
                item.status = item?.schedule_list?.filter(({ status }) => { return status === "Failed" })?.length ? "Failed" :
                    item?.schedule_list?.filter(({ status }) => { return status === "Running" })?.length ? "Running" :
                        item?.schedule_list?.filter(({ status }) => { return status === "Pending" })?.length ? "Pending" :
                            item?.schedule_list?.filter(({ status }) => { return status === "Succeeded" })?.length ? "Succeeded" :
                                item?.schedule_list?.filter(({ status }) => { return status === "Enabled" })?.length ? "Enabled" :
                                    item?.schedule_list?.filter(({ status }) => { return status === "Disabled" })?.length ? "Disabled" : "Pending";
                return item
            })
            // scheduler_list.push({ id: "3234", service_name: "MongoDB", title: "MongoDB", start: "2021-04-29 08:09:23", schedule_list: [] })
            set_backup_scheduler(scheduler_list);
        }
    }, [filter_backup_list, view_type])

    useEffect((): void => {
        if (backup_scheduler && filter_backup_list) {
            set_backup_scheduler_display(view_type === "dayGridMonth" ? backup_scheduler : filter_backup_list);
        }
    }, [backup_scheduler, view_type, filter_backup_list])

    useEffect((): void => {
        set_upcoming_display_list(view_type === "dayGridMonth" ?
            upcoming_schedule_list : JSON.parse(sessionStorage.getItem("calendar_upcoming") || '{}'));
    }, [upcoming_schedule_list, view_type])

    const showDetail = useCallback((eventInfo) => {
        set_view_type(eventInfo?.view?.type);
        sessionStorage.setItem('scheduler_view', eventInfo?.view?.type);
    }, [])

    const database_style: any = useRef({
        MongoDB: "#E5F6F1", PostgreSQL: "#EDF3FC", InfluxDB: "#FEF6E6"
        // MongoDB: "rgba(0,169,113, 0.1)", PostgreSQL: "rgba(74,142,228, 0.1)",  InfluxDB: "rgba(245, 167, 10, 0.1)"
    })

    const database_list: React.MutableRefObject<{ label: string, value: string }[]> = useRef([
        { label: 'MongoDB', value: "MongoDB" },
        { label: 'PostgreSQL', value: "PostgreSQL" },
        { label: 'InfluxDB', value: "InfluxDB" }
    ]);

    const renderEventContent = useCallback((eventInfo) => {
        // switch (eventInfo.event.title) {
        //     case "MongoDB":
        //         eventInfo.backgroundColor = "MongoDB-green";
        //         break;
        //     case "PostgreSQL":
        //         eventInfo.backgroundColor = "PostgreSQL-blue";
        //         break;
        //     case "InfluxDB":
        //         eventInfo.backgroundColor = "InfluxDB-yellow";
        //         break;
        //     default:
        //         break;
        // }
        switch (eventInfo?.event?.extendedProps?.status) {
            case "Failed":
                eventInfo.backgroundColor = "bg-Failed";
                break;
            case "Running":
                eventInfo.backgroundColor = "bg-Running";
                break;
            case "Succeeded":
                eventInfo.backgroundColor = "bg-Succeeded";
                break;
            case "Pending":
                eventInfo.backgroundColor = "bg-Pending";
                break;
            case "Enabled":
                eventInfo.backgroundColor = "bg-Enabled";
                break;
            case "Disabled":
                eventInfo.backgroundColor = "bg-Disabled";
                break;
            default:
                eventInfo.backgroundColor = "bg-Pending";
                break;
        }

        let past: boolean | undefined, current_day: boolean | undefined;
        let current_day_backups: schedule_item[] = [], current_day_schedules: schedule_item[] = [];

        if (current_time) {
            past = (Date.parse(eventInfo?.event?.extendedProps.schedule_list?.[0]?.start) - current_time) < 0;
            current_day = eventInfo?.event?.extendedProps?.schedule_list?.[0]?.start?.slice(0, 10) === get_time(current_time).slice(0, 10);
            if (current_day) {
                eventInfo?.event?.extendedProps?.schedule_list?.map((item: any) => {
                    return Date.parse(item?.start) - current_time <= 0 ? current_day_backups.push(item) : current_day_schedules.push(item)
                })
            }
        };

        const week_details =
        {
            title: "details",
            label_list: [
                "service_name",
                "instance_name",
                "status",
                "cron_start_time",
                "cron_end_time",
                "backup_type"
            ]
        };

        const to_backup_page = (record: any)=>{
            const newRecord: any = {
                ...record,
                subscriptionId: record?.subscription_id,
                service: record?.service_name,
                instanceId: record?.instance?.id,
                instanceName: record?.instance_name
            };
            set_list_item_selected(newRecord);
            sessionStorage.setItem("sidebarKey", "list_instance");
            sessionStorage.setItem('instance_list_item_selected', JSON.stringify(newRecord));
            props?.history?.push('/service-backup-restore');
        };

        const month_columns = [
            {
                title: formatMessage({ id: "status" }),
                dataIndex: 'status',
                key: 'status',
                render: (status: string) => {
                    return <div>
                        <span className={`text-left pr-6 cursor-default bg-${(status || "Pending")?.toLowerCase()}`}>⬤</span>
                        <span className="m-0 p-0">{status || "Pending"}</span>
                    </div>
                }
            },
            {
                title: formatMessage({ id: "instance_name" }),
                dataIndex: 'instance_name',
                key: 'instance_name',
                render: (instance_name: any, record: any) => {
                    return <Col
                        className="text-ellipsis"
                        style={{ color: "#019ff3", cursor: "pointer", width: "120px", fontWeight: 600 }}
                        title={instance_name}
                        onClick={() => {
                            sessionStorage.setItem("sidebar_selected",
                                record?.status === "Enabled" || record?.status === "Disabled" ? "backup_schedule" : "backup_management");
                            to_backup_page(record)
                        }}
                    >
                        {instance_name}
                    </Col>
                }
            },
            {
                title: formatMessage({ id: ((past && !current_day) || (current_day && !!current_day_backups?.length)) ? "backup_id" : "schedule_name" }),
                dataIndex: 'name',
                key: 'name',
                render: (name: string) => <Col
                    className="text-ellipsis scheduler-backupID"
                    style={{ width: ((past && !current_day) || (current_day && !!current_day_backups?.length)) ? "200px" : "120px" }}
                >
                    {((past && !current_day) || (current_day && !!current_day_backups?.length)) ?
                        <Col style={{ whiteSpace: "normal" }}>
                            <Typography.Paragraph copyable={{ text: name }}>{name}</Typography.Paragraph>
                        </Col> :
                        name}
                </Col>
            },
            {
                title: formatMessage({ id: "cron_start_time" }),
                dataIndex: 'start',
                key: 'start'
            },
        ];

        const schedule_columns = [
            {
                title: formatMessage({ id: "status" }),
                dataIndex: 'status',
                key: 'status',
                render: (status: string) => {
                    return <div>
                        <span className={`text-left pr-6 cursor-default bg-${(status || "Pending")?.toLowerCase()}`}>⬤</span>
                        <span className="m-0 p-0">{status || "Pending"}</span>
                    </div>
                }
            },
            {
                title: formatMessage({ id: "instance_name" }),
                dataIndex: 'instance_name',
                key: 'instance_name',
                render: (instance_name: any, record: any) => {
                    return <Col
                        className="text-ellipsis"
                        style={{ color: "#019ff3", cursor: "pointer", width: "120px" }}
                        title={instance_name}
                        onClick={() => {
                            sessionStorage.setItem("sidebar_selected",
                                record?.status === "Enabled" || record?.status === "Disabled" ? "backup_schedule" : "backup_management");
                            to_backup_page(record)
                        }}
                    >
                        {instance_name}
                    </Col>
                }
            },
            {
                title: formatMessage({ id: "schedule_name" }),
                dataIndex: 'name',
                key: 'name',
                render: (name: string) => <Col
                    className="text-ellipsis"
                    style={{ width: "120px" }}
                    title={name}>
                    {name}
                </Col>
            },
            {
                title: formatMessage({ id: "cron_start_time" }),
                dataIndex: 'start',
                key: 'start'
            },
        ];

        const content: JSX.Element | any = (
            eventInfo?.view?.type === "dayGridMonth" ?
                current_day ?
                    <Col className="py-5">
                        {!!current_day_backups?.length &&
                            <Fragment>
                                <Row className="mb-10 font-w-6">{formatMessage({ id: "backup_info" })}</Row>
                                <Table
                                    size="small"
                                    className={`scheduler-table ${current_day_schedules?.length ? "mb-10" : ""}`}
                                    pagination={current_day_backups?.length > 5 ? { pageSize: 5 } : false}
                                    rowKey={(record: any) => record?.id}
                                    dataSource={current_day_backups}
                                    columns={month_columns} />
                            </Fragment>}
                        {!!current_day_schedules?.length &&
                            <Fragment>
                                <Row className="mb-10 font-w-6">{formatMessage({ id: "schedule_info" })}</Row>
                                <Table
                                    size="small"
                                    className="scheduler-table"
                                    pagination={current_day_schedules?.length > 5 ? { pageSize: 5 } : false}
                                    // 表格行 key 取值
                                    rowKey={(record: any) => `${record?.id} ${record?.start}`}
                                    dataSource={current_day_schedules}
                                    columns={schedule_columns} />
                            </Fragment>}
                    </Col>
                    : <Table
                        size="small"
                        className="scheduler-table"
                        pagination={eventInfo?.event?.extendedProps.schedule_list?.length > 5 ? { pageSize: 5 } : false}
                        // 表格行 key 取值
                        rowKey={(record: any) => `${record?.id} ${record?.start}`}
                        dataSource={eventInfo?.event?.extendedProps?.schedule_list}
                        columns={month_columns} />
                :
                <Row className="week-description backup-description">
                    <Descriptions className="w-100" bordered size="small" column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
                        {week_details?.label_list?.map(cell =>
                            <Descriptions.Item
                              key={cell}
                                label={<span title={formatMessage({ id: cell })}>{formatMessage({ id: cell })}</span>}
                            >
                                {cell === "cron_start_time" ?
                                    eventInfo?.event?.extendedProps?.start_time?.includes("0001") ? "--/--/---- --:--:--" : get_time(eventInfo?.event?.extendedProps?.start_time) :
                                    cell === "cron_end_time" ? eventInfo?.event?.extendedProps?.end_time?.includes("0001") ? "--/--/---- --:--:--" : get_time(eventInfo?.event?.extendedProps?.end_time) :
                                        cell === "status" ? <div>
                                            <span className={`text-left pr-6 cursor-default bg-${(eventInfo?.event?.extendedProps?.status || "Pending")?.toLowerCase()}`}>⬤</span>
                                            <span className="m-0 p-0">{eventInfo?.event?.extendedProps?.status || "Pending"}</span>
                                        </div> :
                                            cell === "instance_name" ? <Tooltip title={eventInfo?.event?.extendedProps?.instance?.name}>
                                                <Col className="text-ellipsis-more line-clamp-2 w-190 instance_name_w"
                                                    onClick={() => {
                                                        sessionStorage.setItem("sidebar_selected",
                                                            eventInfo?.event?.extendedProps?.status === "Enabled" || eventInfo?.event?.extendedProps?.status === "Disabled" ? "backup_schedule" : "backup_management");
                                                        to_backup_page(eventInfo?.event?.extendedProps)
                                                    }}
                                                >
                                                    {eventInfo?.event?.extendedProps?.instance?.name}
                                                </Col>
                                            </Tooltip> :
                                                cell === "backup_type" ? <FormattedMessage id={eventInfo?.event?.extendedProps[cell]} /> :
                                                    eventInfo?.event?.extendedProps[cell] || "--"}
                            </Descriptions.Item>
                        )}
                    </Descriptions>
                </Row>
        );

        return <Col className={`event-cell ${eventInfo?.view?.type === "timeGridWeek" ? "w-45" : "w-100p"}`}>
            <Popover
                content={content}
                placement="top"
                overlayClassName="schdule-popover"
                color={database_style?.current[eventInfo?.event?.extendedProps?.database]}
                title={current_day ? undefined : formatMessage({
                    id: `${eventInfo?.view?.type === "dayGridMonth" ?
                        past ? "backup_info" : "schedule_info"
                        : "details"}`
                })}>
                <Col className="schedule-container">
                    <Row justify="center" align="middle">
                        {/* <ClockCircleOutlined className="clock-icon" /> */}

                        <Row align="middle" className="flex-nonwrap w-100">
                            {/* <span className={`pr-6 font-16 ${`bg-${eventInfo.event.extendedProps.status?.toLowerCase()}`}`}>⬤</span> */}
                            <Col className={`schedule-cell ${eventInfo?.view?.type === "timeGridWeek" ? "smaller-cell" : ""} d-flex align-items-center w-100 ${eventInfo?.backgroundColor}`}>
                                {eventInfo?.view?.type === "dayGridMonth" ? <Fragment>
                                    <img
                                        src={eventInfo?.event?.extendedProps?.service_name === "MongoDB" ? MongoDB :
                                            eventInfo?.event?.extendedProps?.service_name === "PostgreSQL" ? PostgreSQL : InfluxDB}
                                        alt={eventInfo?.event?.extendedProps?.service_name}
                                        className={`mr-10 ${eventInfo?.event?.extendedProps?.service_name === "MongoDB" ? "MongoDB_img" :
                                            eventInfo?.event?.extendedProps?.service_name === "PostgreSQL" ? "PostgreSQL_img" : "InfluxDB_img"}`} />
                                    <span className="all_text_color">{eventInfo?.event?.extendedProps?.schedule_list?.length}</span>
                                </Fragment> :
                                    <Col>
                                        <img
                                            src={eventInfo?.event?.extendedProps?.service_name === "MongoDB" ? MongoDB :
                                                eventInfo?.event?.extendedProps?.service_name === "PostgreSQL" ? PostgreSQL : InfluxDB}
                                            alt={eventInfo?.event?.extendedProps?.service_name}
                                            className={eventInfo?.event?.extendedProps?.service_name === "MongoDB" ? "MongoDB_img" :
                                                eventInfo?.event?.extendedProps?.service_name === "PostgreSQL" ? "PostgreSQL_img" : "InfluxDB_img"} />
                                        {/* <Col>{eventInfo.timeText}</Col> */}
                                        {/* <Row className="text-ellipsis d-inline text-center ">
                                            {eventInfo.event.extendedProps.instance?.name}
                                        </Row> */}
                                    </Col>}
                            </Col>
                        </Row>
                    </Row>
                </Col>
            </Popover>
        </Col >
    }, [formatMessage, database_style, props?.history, current_time, set_list_item_selected])

    // useEffect(() => {
    //     console.log("backup ", backup_scheduler_display);
    // }, [backup_scheduler_display])

    const scheduler_view = useMemo((): JSX.Element => {
        return <Col span={24} className="px-20 pt-10 schedule-content">
            <NoPermissionModal />
            {loading && <Col className="loading-spin">
                <Spin />
            </Col>}
            <Row align="middle" className="management-label-line font-w-6 theme-color mb-20">
                <FormattedMessage id="backup_scheduler" />
            </Row>
            <Row>
                <Col className="scheduler-label">
                    <Col className="scheduler-left">
                        {/* <Col className="px-20 py-20">
                        <Col className="remark-text mb-10">Job Type</Col>
                        <Select
                            style={{ width: '100%' }}
                            showSearch
                            placeholder={formatMessage({ id: "please_select" }, { type: "Job Type".toLowerCase() })}
                        >
                            <Option key="0" value="Database Services">Job Type1</Option>
                        </Select>
                    </Col> */}
                        <Col className="px-20 py-20">
                            <Col className="remark-text mb-18">{formatMessage({ id: 'database_services' })}</Col>
                            <Select
                                style={{ width: '100%' }}
                                showSearch
                                defaultValue="all"
                                onChange={(e: any) => {
                                    set_service_type(e);
                                }}>
                                <Option key="all" value="all">{formatMessage({ id: "all" })}</Option>
                                {database_list?.current?.length && database_list?.current?.map(({ label, value }) => (
                                    <Option key={label} value={value}>{value}</Option>
                                ))}
                            </Select>
                        </Col>
                        <Col className="split-line"></Col>
                        <Col className="px-20 py-20">
                            <Col className="remark-text mb-18">{formatMessage({ id: "instance_status" })}</Col>
                            <Row>
                                {backup_status?.current?.map((item: any, index: number) => (
                                    <Col className="status-cell" key={`${item?.status}-${index}`}>
                                        <span className={`pr-6 ${item?.color}`}>⬤</span>
                                        <span className="status-text">{item?.status}</span>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Col>
                    <Col className="scheduler-left">
                        <Col className="px-20 py-20">
                            <Col className="remark-text mb-15">{formatMessage({ id: "upcoming_schedule" })}</Col>
                            {upcoming_display_list?.map((item: any, index: number) => (
                                //  ${item.service === "MongoDB" ? "MongoDB-green" : item.service === "PostgreSQL" ? "PostgreSQL-blue" : "InfluxDB-yellow"}
                                <Col className={`database-cell mb-18 bg-services`} key={`${item?.service}=${index}`}>
                                    <Row align="middle" className="mb-5">
                                        <img
                                            src={item?.service === "MongoDB" ? MongoDB :
                                                item?.service === "PostgreSQL" ? PostgreSQL : InfluxDB}
                                            alt={item?.service}
                                            className="mr-5 ml--5 service_text_img" />
                                        <Col className="font-w-6">{item?.service}</Col>
                                    </Row>
                                    {item?.name ? <Fragment>
                                        <Tooltip title={item?.name}>
                                            <Row className="ml-25 h-25 text-ellipsis d-inline w-160">{item?.name}</Row>
                                        </Tooltip>
                                        <Row className="ml-25 h-25">{item?.time}</Row>
                                    </Fragment> :
                                        <Row align="middle" className={`no_schedule ${loading && view_type === "dayGridMonth" ? "justify-center" : "ml-25"}`}>
                                            {loading && view_type === "dayGridMonth" ? <Spin /> :
                                                <Col>{formatMessage({ id: "no_upcoming_schedule" })}</Col>}
                                        </Row>
                                    }
                                </Col>
                            ))}
                        </Col>
                    </Col>
                </Col>
                <Col className="full-calendar">
                    <FullCalendar
                        initialView={view_type}
                        eventClassNames="event-style"
                        editable={true}
                        // eventBackgroundColor="blue"
                        height={700}
                        dayMaxEvents={false}
                        fixedWeekCount={true}
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        locale='en'
                        slotDuration="01:00:00"
                        handleWindowResize={true}
                        // slotLabelFormat="h(:mm)a"
                        buttonText={{
                            today: formatMessage({ id: "back_today" }),
                            month: formatMessage({ id: "cron_month" }),
                            week: formatMessage({ id: "week" }),
                            day: formatMessage({ id: "schedule_day" }),
                            list: "list"
                        }}
                        headerToolbar={{
                            // left: "prevYear,prev,next,nextYear today", // 上一年，上一月，下一月，下一年 今天
                            left: "prev today next",
                            center: "title", // 当前年月
                            right: "dayGridMonth,timeGridWeek,timeGridDay" // 日 月 周
                        }}
                        allDaySlot={false}
                        firstDay={0}  // 0 默认周日
                        slotLabelFormat={{
                            hour: '2-digit',
                            minute: '2-digit',
                            meridiem: true,
                            hour12: true
                        }}
                        datesSet={(e: any) => {
                            sso_subscriptions?.length && e?.view?.type !== view_type && set_loading(true);
                            set_view_type(e?.view?.type);
                            set_start_time(new Date(e?.startStr)?.toISOString()?.replace(/.000/g, ""));
                            set_end_time(new Date(e?.endStr)?.toISOString()?.replace(/.000/g, ""));
                        }}
                        // titleFormat="MMM D YYYY"
                        // eventClassNames={["s", "sds"]}
                        // dayCellClassNames={["bg-color", "bg-color1", "bg-color2"]}
                        // eventsSet={handleEvents}
                        viewDidMount={showDetail}
                        // dateClick={showDetail}
                        eventContent={renderEventContent}
                        eventSources={[backup_scheduler_display]}
                        eventClick={(e: any) => {
                            // if (view_type !== "dayGridMonth") {
                            //     sessionStorage.setItem("sidebar_selected",
                            //         e.event.extendedProps?.status === "Enabled" || e.event.extendedProps?.status === "Disabled" ? "backup_schedule" : "backup_management");
                            //     props.history.push(`/service/backup?subscriptionId=${e.event.extendedProps?.subscription_id}&instanceId=${e.event.extendedProps?.instance?.id}&serviceName=${e.event.extendedProps.service_name}`);
                            // }
                        }}
                    //默认展示当前日期
                    // initialDate={date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate()}
                    />
                </Col>
            </Row>
        </Col>
    }, [backup_scheduler_display, formatMessage, loading, showDetail, renderEventContent, view_type, upcoming_display_list, Option, sso_subscriptions])

    return scheduler_view

};

export default injectIntl(withRouter(BackupScheduler) as any);
